;(function () {
  'use strict';

  /**
   * プレビューリスト作成
   * @param   {object}  files
   * @returns {string}  previews
   */
  function buildImagePreviews(files, itemId) {
    var previews = '';
    $.each(files, function (index, file) {
      if (file.error) {
        toastr.error(file.error);
        return true;  // continue
      } else {
        previews += buildImagePreview(file, itemId);
      }
    });

    return previews;
  }

  /**
   * プレビュー作成
   * @param   {object}  file
   * @returns {string}  previewItem
   */
  function buildImagePreview(file, itemId) {
    var image = '<img src="' + file.url + '" class="photo-preview__image" alt="" />';
    var deleteButton = '<p class="photo-preview__delete js-preview-delete"><a><i class="fa fa-times" aria-hidden="true"></i></a></p>';
    var fileForm = '<input type="hidden" name="report_item[image][' + itemId + '][]" value="' + file.name + '">';
    var previewItem = '<li class="photo-preview__item" data-cy="image-preview-file">' + image + deleteButton + fileForm + '</li>';

    return previewItem;
  }

  /**
   * プログレスバー 表示
   */
  function showProgress(progress) {
    progress.removeClass('hidden');
  }

  /**
   * プログレスバー 非表示
   */
  function hideProgress(progress) {
    progress.addClass('hidden');
  }

  $(function () {
    // 画像ドラッグ・アンド・ドロップのブラウザデフォルト動作停止
    $(document).on('drop dragover', function (e) {
      e.preventDefault();
    });

    //一度にアップロードできる画像ファイル数の制限
    var maxImageFiles = 30

    //ファイル選択からアップロードした時
    $('#report-item-image-file').change(function (){
      var imageForm = document.getElementById('report-item-image-file');
      if(imageForm.files.length > maxImageFiles){
        imageForm.value = ""
        window.toastr.error("アップロードする画像は、" + maxImageFiles + "枚以下にしてください。", { timeOut: 4000 }, { preventDuplicates: true });
      }
    });

    //ドラッグ＆ドロップでアップロードした時
    $('#report-item-image-fileupload-label').on('drop', function(e) {
      var imageForm = e.originalEvent.dataTransfer;
      if(imageForm.files.length > maxImageFiles){
        e.stopPropagation();
        e.preventDefault();
        window.toastr.error("アップロードする画像は、" + maxImageFiles + "枚以下にしてください。", { timeOut: 4000 }, { preventDuplicates: true });
      }
    });

    var $form = $('form[data-report-post-form]');

    // ファイルアップロード
    $form.find('input[type="file"].upload__report-item-image').each(function () {
      var $uploadForm = $(this).closest('.report-item-image-fileupload');
      var $label = $uploadForm.find('.report-item-media-fileupload-label');
      var $preview = $uploadForm.find('.photo-preview');

      $(this).fileupload({
        dropZone: $uploadForm,
        pasteZone: $uploadForm,
        url: '/temporary_images?resource_name=report_item_image&preview_width=400',
        dataType: 'json',
        method: 'POST',
        formData: {},
        messages: {
          acceptFileTypes:　'非対応のファイル形式です。',
          maxFileSize: '30MBを超えています。'
        },
        processQueue: [
          {
            action: 'validate',
            fileTypes: /^image\/.+/,
            maxFileSize: 1024 * 1024 * 30,  // 30MB
          }
        ],

        /**
         * アップロード開始イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        start: function (e, date) {
          var $progress = $preview.find('.photo-preview__progress');
          showProgress($progress);
        },

        /**
         * アップロード中イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        progressall: function (e, data) {
          var $progressBar = $preview.find('.photo-preview__progress-bar');
          $progressBar.css('width', parseInt(data.loaded / data.total * 100, 10) + '%');
        },

        /**
         * ファイル毎のアップロード完了イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        done: function (e, data) {
          // プレビュー表示
          var itemId = $(this).data('item-id');
          var previews = buildImagePreviews(data.result.files, itemId);
          if (previews) {
            var $previewList = $preview.find('.photo-preview__list');
            if ($previewList.length > 0) {
              $previewList.append($(previews));
            } else {
              $preview.append($('<ul class="photo-preview__list">' + previews + '</ul>'));
            }
          }
        },

        /**
         * アップロード完了イベントハンドラ
         * @param {event}   e
         * @param {object}  data
         */
        stop: function (e, date) {
          var $progress = $preview.find('.photo-preview__progress');
          hideProgress($progress);
        }
      }).on('fileuploadprocessalways', function (e, data) {
        if(data.files.error) {
          window.toastr.error(data.files[0].name + "は" + data.files[0].error, { timeOut: 4000 }, { preventDuplicates: true });
        } else {
          data.submit()
        }
      });
    });

    // アップロードキャンセル（画像削除）
    $form.on('click', '.js-preview-delete', function () {
      var $previewItem = $(this).closest('.photo-preview__item');
      $previewItem.remove();
    });
  });
}.call(this));
